module.exports = __webpack_public_path__ + "static/scale-model-of-be-someone-in-houston-texas-eb541de08cd177b44277bfc4981319f4.png";